import { Module } from 'vuex';
import { State } from '@/stores/user/state';
import { Getters } from '@/stores/user/getters';
import { Mutations } from '@/stores/user/mutations';
import { Actions } from '@/stores/user/actions';

export class UserStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
